<template>
  <div class="main-tabs">
    <el-row>
      <el-col>
        <el-tabs
          v-model="defaultTab"
          @tab-click="onClickTab">
          <el-tab-pane
            v-for="item in tabsLabelHeader"
            :key="item.name"
            :label="item.name"
            :name="item.active"/>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'FormTabs',
  props: {
    tabsLabelHeader: {
      type: Array,
      default: null,
      required: true
    },
    tabDataContent: {
      type: Object,
      default: null
    }
  },
  computed: {
    defaultTab: {
      get: function () {
        return this.$route.name
      },
      set: function () {
        return 'customer-info'
      }
    }
  },
  methods: {
    onClickTab (t) {
      this.$emit('onClickTab', t)
    }
  }
}
</script>

<style lang="scss">
  .main-tabs{
    background-color: #ffffff;
    .el-tabs__header{
      margin-bottom: 0px;
      .el-tabs__nav-wrap{
        padding:  0 20px;
        &::after{
          height: 1px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_shared/form-tabs.vue